"use client";

import { createContext } from "react";
import type { FormFunnelFlowScreen } from "@portal/app/_components/formFunnel/types";

/** Live screen state updates blocks without replacing Puck's component definitions. */
export const PageFlowContext = createContext<
  | (FormFunnelFlowScreen & {
      topOffset: number;
      pageHasHeading?: boolean;
    })
  | null
>(null);
